import { EmojiPeople } from '@mui/icons-material'
import ProfessionalFiguresList from './ProfessionalFiguresList'
import ProfessionalFiguresCreate from './ProfessionalFiguresCreate'
import ProfessionalFiguresEdit from './ProfessionalFiguresEdit'

const drinkSectionIndex = {
  icon: EmojiPeople,
  list: ProfessionalFiguresList,
  edit: ProfessionalFiguresEdit,
  create: ProfessionalFiguresCreate,
}

export default drinkSectionIndex
